// @file Helpers for dealing with emojis
import { __ } from 'bits/intl'

const categoryTitles = {
  people: __('Smileys & People'),
  nature: __('Animals & Nature'),
  food: __('Food & Drink'),
  activity: __('Activity'),
  travel: __('Travel & Places'),
  objects: __('Objects'),
  symbols: __('Symbols'),
  flags: __('Flags'),
}

// TODO: pick better icons so that they have same vertical alignment
const categoryIcons = {
  people: 'mood',
  nature: 'cat',
  food: 'restaurant',
  activity: 'basketball',
  travel: 'directions_car',
  objects: 'lightbulb',
  symbols: 'favorite',
  flags: 'flag',
}

// Joypixel emojis
const COLD_FACE_EMOJI = {
  iconSrc: 'https://padlet.net/icons/6.6/svg/1f976.svg',
  iconAlt: __('Cold Face'),
}

const FACE_WITH_ROLLING_EYES_EMOJI = {
  iconSrc: 'https://padlet.net/icons/6.6/svg/1f644.svg',
  iconAlt: __('Face With Rolling Eyes'),
}

const WAVING_HAND_EMOJI = {
  iconSrc: 'https://padlet.net/icons/6.6/svg/1f44b.svg',
  iconAlt: __('Waving Hand'),
}

const OPEN_HANDS_ICON = {
  iconSrc: 'https://padlet.net/icons/6.6/svg/1f450.svg',
  iconAlt: __('Open hands'),
}

export {
  categoryTitles,
  categoryIcons,
  COLD_FACE_EMOJI,
  FACE_WITH_ROLLING_EYES_EMOJI,
  WAVING_HAND_EMOJI,
  OPEN_HANDS_ICON,
}
